/**
 * 审计域共享类型（`04-api-contract.md` §24）。
 *
 * **本文件的存在理由**：`actorType` 的三值白名单原先只在
 * `apps/api/src/modules/audit/audit.constants.ts` 里有一份，
 * 社团端的审计页因此**就地又抄了一份**（`AuditLogsPage.tsx`）。
 * 两份会各自漂移：后端加一个主体类型、前端下拉框不会跟着变，
 * 而这类不一致不会让任何测试变红 —— 只是筛选器少一个选项。
 *
 * 权威校验仍在服务端（`@IsEnum(ACTOR_TYPES)`）：前端拿着这份白名单只用于
 * 渲染下拉框，**不是**授权依据。
 */
export const ACTOR_TYPES = ['PLATFORM', 'TENANT', 'ORGANIZER'];
/** 主体类型的中文标签（前端展示用） */
export const ACTOR_TYPE_LABELS = {
    PLATFORM: '平台',
    TENANT: '社团',
    ORGANIZER: '主办方',
};
//# sourceMappingURL=audit.js.map